import { CrownOutlined, RightOutlined } from '@ant-design/icons'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import { managerRoles, useRestriction } from 'app/lib/hooks/useRestriction'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

// Sales books the package in HubSpot, so it can exist without a Stripe subscription.
// Only the manager roles reach the package tab in the settings.
const PackageBadge: React.FC = () => {
  const customer = useCurrentCustomer()
  const { tComponent } = useTranslation({ componentType: 'navigation', scope: 'sidebar' })
  const { restricted } = useRestriction({ allowFor: managerRoles })
  const navigate = useNavigate()

  if (!customer?.active_package) return null

  const content = (
    <>
      <span className="sider-package__icon">
        <CrownOutlined />
      </span>
      <span className="sider-package__text">
        <span className="sider-package__label">{tComponent({ id: 'package' })}</span>
        <span className="sider-package__name">{customer.active_package}</span>
      </span>
    </>
  )

  if (restricted) {
    return (
      <div className="sider-package" data-testid="sider-package">
        {content}
      </div>
    )
  }

  return (
    <button
      type="button"
      className="sider-package sider-package--link"
      data-testid="sider-package"
      onClick={() => navigate(Routes.Setting.collection().packages)}>
      {content}
      <RightOutlined className="sider-package__arrow" />
    </button>
  )
}

export default PackageBadge
